import { FeedSelectorConfiguration } from './feed-selector-configuration.model';

export class GridSelectorDetail {
    config: FeedSelectorConfiguration;
    parent: Object;
    selectedRows: any[];
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/shared/models/grid-selector-detail.model.ts